import React from 'react';
import PremiumCTA from './PremiumCTA';

interface BannerMenorProps {
  style?: any;
}

const BannerMenor: React.FC<BannerMenorProps> = ({ style }) => {
  return (
    <PremiumCTA compact={true} />
  );
};

export default BannerMenor;